import Close16 from '@carbon/icons-react/es/close/16';
import { Input, Typography } from 'antd';
import styled, { css } from 'styled-components';
import { Button } from 'components/atoms/button';
import { Form } from 'components/atoms/form';
import {
  BodyLong01,
  BodyShort01,
  ProductiveHeading06,
  Caption01,
} from 'components/styles';

const { Text } = Typography;
const { TextArea } = Input;

export const EditorHeading = styled(TextArea)<{
  isPublished?: boolean;
}>`
  padding: 0 var(--spacing-03) 0 0;
  background: transparent;
  border: none;
  border-bottom: 1px solid transparent;
  cursor: text;

  &:focus,
  &:hover {
    border-color: var(--border-color);
  }
  resize: none;
  box-shadow: none !important;
  &:read-only {
    cursor: default;
  }
  ${({ isPublished }) => (isPublished ? ProductiveHeading06 : '')};
  ${({ isPublished }) =>
    isPublished
      ? css`
          margin: var(--spacing-03) 0;
          &:focus,
          &:hover,
          &:active {
            border-color: transparent !important;
          }
        `
      : ''};
`;

export const EditorContainer = styled.div<{
  isPublished: boolean;
  isFullScreen: boolean;
}>`
  background: var(--coolest-gray-10);
  padding: var(--spacing-05) var(--spacing-06);

  ${({ isPublished }) =>
    isPublished
      ? css`
          padding: var(--spacing-05) var(--spacing-06) var(--spacing-06);
        `
      : ''};

  ${({ isFullScreen }) =>
    isFullScreen
      ? css`
          padding: var(--spacing-07) var(--spacing-10);
        `
      : ''};
  .rich-text-editor_rte__j-SY6 {
    min-height: 0px;
  }
  .ck.ck-content.ck-editor__editable.ck-editor__editable_inline {
    min-height: var(--height-sm);
    width: 520px;
    background-color: var(--coolest-gray-10);
    padding: 0px;
    p {
      width: 500px;
      word-wrap: wrap;
    }
    :hover,
    :focus {
      border-bottom: 1px solid var(--coolest-gray-30);
    }
  }
`;

export const PublishedDate = styled.span`
  ${BodyLong01};
  color: var(--gray-70);
`;

export const Username = styled(Text)`
  ${BodyShort01};
  margin-right: var(--spacing-02);
  max-width: 112px;
`;

export const CollaboratorsTriggerButton = styled(Button)`
  padding-left: 0;
  padding-right: 0;
`;

export const FormItem = styled(Form.Item)`
  padding-bottom: var(--spacing-01) !important;
  margin-bottom: 0;
  &.ant-form-item-control-input {
    margin-bottom: 0;
  }
`;

export const Label = styled.div`
  ${BodyShort01};
  color: var(--gray-50);
  text-align: left;
  width: 70px;
`;

export const CCLabel = styled.div`
  width: var(--spacing-07);
  ${BodyShort01};
  color: var(--gray-50);
`;

export const SubHeader = styled.div<{ isFullScreen: boolean }>`
  padding: var(--spacing-02) var(--spacing-06);
  border-bottom: ${(props) =>
    props.isFullScreen ? 'none' : '1px solid var(--border-color)'};
  display: flex;
  align-items: center;
`;

export const Wrapper = styled.div<{
  isPublished: boolean;
  isFullScreen: boolean;
}>`
  width: 100%;
  margin-bottom: ${({ isPublished, isFullScreen }) =>
    isPublished ? (isFullScreen ? 'none' : 'var(--spacing-05)') : 'none'};
`;

export const FlexWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const CCWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-04);
`;
export const CCContentWrapper = styled(CCWrapper)`
  gap: var(--gray-03);
  ${Caption01};
  color: var(--gray-50);
`;
export const CCPopoverWrapper = styled.div`
  padding: var(--spacing-05);
  min-width: 296px;
  max-width: 512px;
`;

export const PublishedBy = styled.div`
  margin-bottom: var(--spacing-03);
`;

export const CCPopoverContent = styled.div`
  display: flex;
  gap: var(--spacing-05);
`;

export const AddMailWrapper = styled(CCPopoverContent)`
  align-items: center;
  width: 100%;
`;

export const AddStatusButton = styled(Button)`
  padding-left: 0;
  padding-right: 0;
`;

export const CloseIcon = styled(Close16)`
  border-radius: 50%;
  margin-left: var(--spacing-02);
  &:hover {
    background-color: var(--red-30);
    color: var(--red-60);
  }
`;

export const Spacer = styled.div`
  margin-right: 18px;
`;
